<template>
    <div>
        <img v-bind:src="imageSrc" v-bind:alt="alt" v-if="videoId">
        <img v-bind:src="defaultPlaceholder" v-bind:alt="alt" v-if="!videoId">
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                default: 'youtube'
            },
            defaultPlaceholder: {
                default: '/img/default-placeholder.png'
            },
            alt: {
                default: ''
            },
            videoUrl: {
                required: true
            },
        },

        data() {
            return {
                videoId: this.$youtube.getIdFromUrl(this.videoUrl),
                imageSrc: 'https://img.youtube.com/vi/' + this.$youtube.getIdFromUrl(this.videoUrl) + '/maxresdefault.jpg'
            }
        },

        mounted() {
            console.log('Vieo Preview Component Mounted.');
        }
    }
</script>
